import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguimiento-todo',
  templateUrl: './seguimiento-todo.component.html',
  styleUrls: ['./seguimiento-todo.component.sass']
})
export class SeguimientoTodoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
